import CosParticipantContainer from "./ParticipantList.Container";

export default CosParticipantContainer;